import CardList from "../../components/styled/CardList";
import CardTitle from "../../components/styled/CardTitle";
import { arrayMap } from "../../utils/array.utils";
import { viewCustomerAgreementFormatterFunc } from "../../utils/moneyReceipt.utils";

export default function CustomerAgreement({ data }) {
  const car = data?.car;
  const additionalCost = car?.additionalCost;
  const formattedData = viewCustomerAgreementFormatterFunc({ ...car, additionalCost });
  return (
    <div className="card border-0">
      <div className="card-body">
        <CardTitle>Customer Agreement</CardTitle>
        <CardList className="list-unstyled mb-0">
          {arrayMap(formattedData, (item, index) => (
            <li key={index}>
              <b>{item.label}</b>: {item.value}
            </li>
          ))}
        </CardList>
      </div>
    </div>
  );
}
